import { jsx as _jsx } from "react/jsx-runtime";
import { TextField as MuiTextField } from '@mui/material';
export function TextField({ value, label, onChange, placeholder, multiline, }) {
    return (_jsx(MuiTextField, { value: value, label: label, placeholder: placeholder, onChange: (event) => onChange(event.target.value), variant: "outlined", multiline: multiline }));
}
//# sourceMappingURL=TextField.js.map